<main style="direction: rtl;" class="">

    <!-- جدول اطلاعات -->

    <div class="">

        <div class="row gx-2 gy-md-0 gy-2">

            <!-- اینپوت جستجو -->

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section table-responsive border border-2 border-secondary mt-2" style="height:calc(100vh - 190px);overflow: auto;">

            <table class="col-12 table table-hover table-striped table-dark rounded-3" id="Export_Excel">

                <thead class="thead-dark">

                    <tr class="">

                        <ng-container *ngIf="parentSection == 'basic-info'">

                            <th class="text-center"> # </th>
    
                            <th class="text-center"> عملیات </th>
    
                            <th class="text-center"> تاریخ </th>
    
                            <th class="text-center"> عنوان </th>
    
                            <th class="text-center"> مقدار </th>

                        </ng-container>

                        <ng-container *ngIf="parentSection == 'full-info'">

                            <th class="col-1 text-center"> # </th>
    
                            <th class="col-1 text-center"> عملیات </th>
    
                            <th class="col-2 text-center"> عنوان </th>
                            
                            <th class="text-center"> زمان </th>
    
                            <th class="col-1 text-center"> مقدار </th>

                        </ng-container>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result; let i = index">

                        <th class="col-1"> {{ i + 1 | faNum }} </th>

                        <ng-container *ngIf="parentSection == 'basic-info'">

                            <th class="">
    
                                <i class="fa fa-bar-chart fa-lg me-2 pointer" aria-hidden="true" (click)="openChart(item)"></i>
    
                                <i class="fa fa-map-marker fa-lg me-2 pointer" aria-hidden="true" (click)="showMap(item)"></i>
    
                            </th>
    
                            <td class="direction-ltr"> {{ item.strDateTime | faNum }} </td>
    
                            <td> {{ item.strComment | faNum }} </td>
    
                            <td> {{ item.strValue | number:'1.0-0' | faNum }} </td>

                        </ng-container>

                        <ng-container *ngIf="parentSection == 'full-info'">

                            <th class="col-1">
                                <i class="fa fa-bar-chart fa-lg me-2 pointer" aria-hidden="true" (click)="openChart(item)"></i>
                            </th>
    
                            <td class="col-4"> {{ item.strPersianName ?? '' | faNum }} </td>

                            <td class="direction-ltr"> {{ item.strDateTime | faNum }} </td>
    
                            <td class="col-1"> {{ item.fValue ?? 0 | number:'1.0-0' | faNum }} </td>

                        </ng-container>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- نقشه -->

    <custom-map *ngIf="showCustom_Map" 
    
        [strValue]="mdl_Map.get('strAddress')?.value"

        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" 
        
        isOpenModal="true" 
        
        isView="true"

        skip_Search="true"

        (mdl_Submit)="showCustom_Map=false">

    </custom-map>

</main>